import React, { useState } from "react";
import axios from "axios"; // Ensure axios is installed and imported
import './AddRole.css';
import { useNavigate, useLocation } from "react-router-dom";

const AddRole = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { roleId } = location.state || {}; // Get the roleId passed from RolesList
    const [roleName, setRoleName] = useState('');
    // Token you provided (for testing purposes)
    const token = `${process.env.REACT_APP_AUTH_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    
    // Cancel button handler
    const handleCancelButtonClick = () => {
        navigate('/roleMaster');
    };

    // Add button handler
    const handleAddButtonClick = () => {
        const newRole = {
            data: {
                roleName: roleName
            }
        };
        axios.post(`${baseUrl}/poims-user-roles`, newRole, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then(() => {
                alert('Role added successfully!');
                navigate('/roleMaster'); // Navigate back to the roles list
            })
            .catch((error) => {
                console.error('Error adding role:', error);
                alert('Error adding role: ' + error.message);
            });
    };

    return (
        <div className="addrolemaster">
            <div className="outside-addrole">
                {/* <h3>Role Master</h3> */}
            </div>
            <div className="addrole">
                <div className="inside-addrole">
                    <h3>Add Role</h3>
                </div>
                <div className="addinside-containerbody">
                    <div className="addrolegroup">
                        <label className="addinside-label">Role Name</label>
                        <input
                            className="addinside-input"
                            value={roleName}
                            onChange={(e) => setRoleName(e.target.value)} // Update state as user types
                            placeholder="Enter Role Name"
                        />
                    </div>
                    <div className="addroleButtons">
                        <button className="add-btn" onClick={handleAddButtonClick}>
                            ADD
                        </button>
                        <button className="btn-add" onClick={handleCancelButtonClick}>
                            CANCEL
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AddRole;
